/** Table-cell class per field type. Split out so CellValue.tsx exports only a component. */

import type { FieldSchema } from '../api/types'

export function cellClassName(field: FieldSchema | undefined, isKey: boolean): string {
  if (isKey) return 'table__cell--key'
  if (!field) return ''
  if (field.type === 'timestamp') return 'table__cell--muted'
  if (field.type === 'minute_of_day' || field.type === 'int') return 'table__cell--num'
  if (field.name === 'updated_by') return 'table__cell--muted'
  return ''
}
